import template from '@components/expertise/discovery/discovery.module.scss'
import { IDiscoveryCards, ISoftwareDiscoveryOrderSection } from '../../discovery.state';
import style from './index.module.scss'
import Image from 'next/image'

interface SoftwareDiscoveryOrderSectionProps {
    section: ISoftwareDiscoveryOrderSection;
}

const SoftwareDiscoveryOrderSectionComponent = ({ section }: SoftwareDiscoveryOrderSectionProps) => {
    return (
        <section className={`${template.section} ${template.section__block_gray}`}>
            <div className={`${template.container} ${template.container__whyDiscovery}`}>
                <h2 className={`${template.whyDiscovery__title} ${template.aboutDiscovery__title}`}>
                    {section.title}
                </h2>
                <div className={template.whyDiscovery__items}>
                    {
                        section.cards.map((item: IDiscoveryCards, index: number) => {
                            return (
                                <div key={index} className={template.whyDiscovery__item}>
                                    <Image src={item.iconSrc} width={item.width} height={item.height} alt={item.title} />
                                    <div className={template.whyDiscovery__item__title}>
                                        {item.title}
                                    </div>
                                    <div className={template.whyDiscovery__item__text}>
                                        {item.text}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default SoftwareDiscoveryOrderSectionComponent;